<div class="pedido-itens-modal-tabelas">
  <div class="form-row">
    <div class="form-group col-sm-12">
      <label><b>Produto:</b></label>

      <input class="form-control form-control-sm" type="text" name="produto_descricao_tabela" [value]="produtoTabelasSelecionado != null ? produtoTabelasSelecionado.name : ''" disabled />
    </div>
  </div>

  @if (produtoTabelasSelecionado != null && produtoTabelasSelecionado.fracionado) {
    <div class="form-row">
      <div class="form-group col-sm-4">
        <label><b>Estoque:</b></label>
        <input class="form-control form-control-sm" type="text" name="produto_estoque_tabela" [value]="produtoTabelasSelecionado != null ? produtoTabelasSelecionado.estoque : ''" disabled />
      </div>
      <div class="form-group col-sm-4">
        <label><b>Fração:</b></label>
        <input class="form-control form-control-sm" type="text" name="produto_fracao_tabela" [value]="produtoTabelasSelecionado != null ? produtoTabelasSelecionado.valorunidade : ''" disabled />
      </div>
      <div class="form-group col-sm-4">
        <label><b>Fracionado:</b></label>
        <input class="form-control form-control-sm" type="text" name="produto_fracao_tabela" [value]="produtoTabelasSelecionado != null ? produtoTabelasSelecionado.estoque_fracionado : ''" disabled />
      </div>
    </div>
  }

  <hr class="mt-2 mb-2" />

  <div class="table-responsive pedido-itens-modal-tabelas-grid">
    <table class="table table-sm pedido-itens-modal-tabelas-tabela">
      <thead>
        <tr>
          <th class="text-center">Código</th>
          <th class="tabela_borda">Tabela</th>
          <th class="tabela_borda">Descrição</th>
          <th class="text-right tabela_borda">Unitário: R$</th>
          @if (produtoTabelasSelecionado != null && produtoTabelasSelecionado.fracionado) {
            <th class="text-right tabela_borda">Fracionado: R$</th>
          }
          @if (configuracao != null && !configuracao.prazo_pagamento_antes_itenspedido && configuracao.utiliza_fator_financeiro && prazoPagamentoSelecionado != null) {
            <th class="text-right tabela_borda bg_tabela_warning">Fator: %</th>
          }
          @if (configuracao != null && !configuracao.prazo_pagamento_antes_itenspedido && configuracao.utiliza_fator_financeiro && prazoPagamentoSelecionado != null) {
            <th class="text-right tabela_borda bg_tabela_danger">C/ Fator: R$</th>
          }
          <th class="text-center tabela_borda">Qtde Mínima</th>
        </tr>
      </thead>

      <tbody>
        @for (produtoTabela of produtoTabelas; track produtoTabela) {
          <tr>
            <td class="text-center" data-label="Código">{{ produtoTabela.codigo }}</td>
            <td class="tabela_borda" data-label="Tabela">{{ produtoTabela.descricao }}</td>
            <td class="tabela_borda" data-label="Descrição">
              <div class="d-flex flex-wrap align-items-center">
                <span>{{ produtoTabela.name }}</span>
                @if (produtoTabela.flag_naoaplicafatorpontuacaofin) {
                  <span class="badge badge-secondary ml-2" title="Este item não aplica fator financeiro nem pontuação">S/ Fat. Fin.</span>
                }
              </div>
            </td>
            <td class="text-right tabela_borda" data-label="Unitário: R$">
              <!-- Sempre usa aplicarPrecoPromocionalETRavar para garantir bypass_desconto_maximo=true, independente de pontuação -->
              @if (configuracao != null && !configuracao.prazo_pagamento_antes_itenspedido && configuracao.utiliza_fator_financeiro && prazoPagamentoSelecionado != null) {
                {{ formatarValoresQuatroCasasDecimais(produtoTabela.preco) }}
              }
              @if (!(configuracao != null && !configuracao.prazo_pagamento_antes_itenspedido && configuracao.utiliza_fator_financeiro && prazoPagamentoSelecionado != null)) {
                <span class="tabela_item_acao" (click)="precoAplicadoSemFator.emit({ idProduto: produtoTabelasSelecionado.id, preco: produtoTabela.preco, produtoTabela: produtoTabela })">{{ formatarValoresQuatroCasasDecimais(produtoTabela.preco) }}</span>
              }
            </td>
            @if (produtoTabelasSelecionado != null && produtoTabelasSelecionado.fracionado) {
              <td class="text-right tabela_borda" data-label="Fracionado: R$">
                {{ formatarValoresQuatroCasasDecimais(produtoTabela.preco_fracionado) }}
              </td>
            }
            @if (configuracao != null && !configuracao.prazo_pagamento_antes_itenspedido && configuracao.utiliza_fator_financeiro && prazoPagamentoSelecionado != null) {
              <td class="text-right tabela_borda bg_tabela_warning" data-label="Fator: %">
                <b>{{ prazoPagamentoSelecionado.fator_financeiro | currency: 'BRL' : '' }}</b>
              </td>
            }
            @if (configuracao != null && !configuracao.prazo_pagamento_antes_itenspedido && configuracao.utiliza_fator_financeiro && prazoPagamentoSelecionado != null) {
              <td class="text-right tabela_borda bg_tabela_danger" data-label="C/ Fator: R$">
                <span class="tabela_item_acao" (click)="precoAplicadoComFator.emit({ idProduto: produtoTabelasSelecionado.id, preco: produtoTabela.preco, produtoTabela: produtoTabela })">{{ formatarValoresQuatroCasasDecimais(produtoTabela.preco * (1 + prazoPagamentoSelecionado.fator_financeiro / 100)) }}</span>
              </td>
            }
            <td class="text-center tabela_borda" data-label="Qtde Mínima">{{ produtoTabela.qtd_minima > 0 ? produtoTabela.qtd_minima : '—' }}</td>
          </tr>
        }
      </tbody>
    </table>
  </div>
</div>
